<template>
  <td>
    <div class="azureLake">
      <v-checkbox
        color="primary"
        class="mt-0"
        hide-details
        style="display: inline-block;"
        v-model="azureLakeForm.enabled"
        label="Azure Data Lake Storage"
        @change="hide = (azureLakeForm.enabled ? !azureLakeForm.enabled : hide)"
      />
      <v-checkbox
        color="primary"
        class="mt-0"
        v-model="isVault"
        hide-details
        style="display: inline-block;"
        label="Use Vault"
        v-if="azureLakeForm.enabled"
      />
      <v-icon style="cursor-pointer" @click="hide = !hide">{{ hide ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
    </div>
    <div v-if="!isVault">
      <v-form
        v-show="!hide"
        ref="azureLakeForm"
        v-model="azureLakeForm.valid"
        lazy-validation
      >
        <v-text-field
          label="Default Endpoints Protocol"
          v-model="azureLakeForm.data.DefaultEndpointsProtocol"
          required
          :rules="[rules.required]"
          validate-on-blur
          class="mb-3"
          @input="setAzureLake"
        />
        <v-text-field
          label="Endpoint Suffix"
          v-model="azureLakeForm.data.EndpointSuffix"
          required
          :rules="[rules.required]"
          validate-on-blur
          class="mb-3"
          @input="setAzureLake"
        />
        <v-text-field
          label="Account Name"
          v-model="azureLakeForm.data.AccountName"
          required
          :rules="[rules.required]"
          validate-on-blur
          class="mb-3"
          @input="setAzureLake"
        />
        <v-text-field
          label="Account Key"
          v-model="azureLakeForm.data.AccountKey"
          required
          :rules="[rules.required]"
          validate-on-blur
          class="mb-3"
          @input="setAzureLake"
        />
      </v-form>
    </div>
    <div v-else>
      <v-form
        v-show="!hide"
        ref="azureLakeForm"
        v-model="azureLakeForm.valid"
        lazy-validation
      >
        <v-select
          v-model="auth_selected"
          :items="scheme"
          item-text="name"
          item-value="value"
          label="Vault authentication scheme"
          required
          :rules="[rules.required]"
          validate-on-blur
          class="mb-3"
        />
        <v-text-field
          label="Vault Service URI with port"
          v-model="azureLakeForm.data.serviceUriWithPort"
          required
          :rules="[rules.required]"
          validate-on-blur
          class="mb-3"
          @input="setAzureLake"
        />
        <v-text-field
          v-if="auth_selected != 'withUserAndPassword'"
          label="Application Role Id"
          v-model="azureLakeForm.data.appRoleId"
          required
          :rules="[rules.required]"
          validate-on-blur
          class="mb-3"
          @input="setAzureLake"
        />
        <v-text-field
          v-if="auth_selected == 'withSecretIdWrapping'"
          label="Wrapping Token"
          v-model="azureLakeForm.data.wrappingToken"
          required
          :rules="[rules.required]"
          validate-on-blur
          class="mb-3"
          @input="setAzureLake"
        />
        <v-text-field
          v-if="auth_selected == 'withOnlySecretId'"
          label="Secret Id"
          v-model="azureLakeForm.data.secretId"
          required
          :rules="[rules.required]"
          validate-on-blur
          class="mb-3"
          @input="setAzureLake"
        />
        <v-text-field
          v-if="auth_selected == 'withUserAndPassword'"
          label="User Name"
          v-model="azureLakeForm.data.username"
          required
          :rules="[rules.required]"
          validate-on-blur
          class="mb-3"
          @input="setAzureLake"
        />
        <v-text-field
          v-if="auth_selected == 'withUserAndPassword'"
          label="Password"
          v-model="azureLakeForm.data.password"
          required
          :rules="[rules.required]"
          validate-on-blur
          class="mb-3"
          @input="setAzureLake"
        />
      </v-form>
    </div>
  </td>
</template>
<script>
export default {
  name: 'azureDataLakeForm',
  props: ['azureLake'],
  created () {
    this.azureLakeForm = this.azureLake
    if (this.azureLake.data.use_vault) {
      this.isVault = this.azureLake.data.use_vault
      this.auth_selected = this.azureLake.data.scheme || this.scheme[0].value
    }
  },
  data () {
    return {
      azureLakeForm: null,
      hide: true,
      rules: {
        required: v => !!v || 'Required.'
      },
      isVault: false,
      auth_selected: null,
      scheme: [
        {
          name: 'AppRole Pull Authentication with SecretID wrapping',
          value: 'withSecretIdWrapping'
        },
        {
          name: 'AppRole Pull Authentication',
          value: 'withOnlySecretId'
        },
        {
          name: 'User and Password',
          value: 'withUserAndPassword'
        }
      ]
    }
  },
  watch: {
    isVault (current) {
      if (current) {
        this.azureLakeForm.data.use_vault = true
        this.setDefaultToNull()
      } else {
        this.azureLakeForm.data.use_vault = false
        this.setVaultToNull()
      }
      this.setAzureLake()
    },
    auth_selected (current) {
      this.azureLakeForm.data.scheme = current
      this.setAzureLake()
    }
  },
  methods: {
    setVaultServicePortToNull () {
      this.azureLakeForm.data.serviceUriWithPort = ''
    },
    setVaultRoleIdToNull () {
      this.azureLakeForm.data.appRoleId = ''
    },
    setVaultWrappingTokenToNull () {
      this.azureLakeForm.data.wrappingToken = ''
    },
    setVaultSecretKeyToNull () {
      this.azureLakeForm.data.secretId = ''
    },
    setVaultUserAndPasswordToNull () {
      this.azureLakeForm.data.username = ''
      this.azureLakeForm.data.password = ''
    },
    setVaultToNull () {
      this.setVaultServicePortToNull()
      this.setVaultRoleIdToNull()
      this.setVaultWrappingTokenToNull()
      this.setVaultSecretKeyToNull()
      this.setVaultUserAndPasswordToNull()
      this.setAzureLake()
    },
    setDefaultToNull () {
      this.azureLakeForm.data.DefaultEndpointsProtocol = ''
      this.azureLakeForm.data.EndpointSuffix = ''
      this.azureLakeForm.data.AccountName = ''
      this.azureLakeForm.data.AccountKey = ''
    },
    setAzureLake () {
      this.isVault && (this.azureLakeForm.data.scheme = this.auth_selected)
      this.$emit('setData', 'azureLake', this.azureLakeForm)
    }
  }
}
</script>
<style lang="scss" scoped>
  .azureLake {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
</style>
